import { useQuery, useQueryClient } from "@tanstack/react-query";
import { CategoriesServices } from "../services";
import * as React from "react";
import { useSocialCoachSession } from "./useSocialCoachSession";
import { categoriesToFilter } from "./categoriesHelpers";

export const useCategories = (
  type: "LIBRARY" | "CAMPAIGN" | "VIDEO_SCRIPT",
  coachIdOverride: number | string | undefined = undefined
) => {
  const queryClient = useQueryClient();
  const { coachId } = useSocialCoachSession();
  const effectiveCoachId = coachIdOverride == undefined ? coachId : coachIdOverride;
  const { data: categories = [] } = useQuery({
    queryKey: ["categories", effectiveCoachId, type],
    queryFn: () => CategoriesServices.get(effectiveCoachId!, type),
    enabled: effectiveCoachId != undefined,
    initialData: [],
  });

  const categoryOptions = React.useMemo(() => {
    return categoriesToFilter(categories);
  }, [categories]);

  const clearCategoryCache = () => {
    queryClient.invalidateQueries({ queryKey: ["categories", effectiveCoachId, type] }).catch(console.error);
  };

  return { categories, categoryOptions, clearCategoryCache };
};
